<script setup lang="ts">
import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import { Initiative } from "@/model";
import { useRoute } from "vue-router";
import Heading from "@/components/Heading.vue";
import { computed } from "vue";
import { ComputedRef } from "@vue/reactivity";
import UrlPreview from "@/components/UrlPreview.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";

const route = useRoute();
const slug = route.params.slug;

const initiative: Initiative = await pb.collection('initiatives').getFirstListItem<Initiative>(`slug = '${slug}'`);

const filesToken = await pb.files.getToken();

const fileUrls: ComputedRef<{ name: string, url: string, }[]> = computed(() => {
  return initiative.files.map(fileName => ({
    name: fileName,
    url: pb.files.getUrl(initiative, fileName, { token: filesToken }),
  }));
});
</script>

<template>
  <Title subtitle="Initiatives">{{ initiative.name }}</Title>
  <Divider/>
  <Content>
    <p>{{ initiative.abstract }}</p>

    <div class="raw-content" v-if="initiative.details" v-html="initiative.details"/>

    <Heading>Files</Heading>
    <UrlPreview v-for="file in fileUrls" :name="file.name" :url="file.url"/>
    <p v-if="fileUrls.length === 0" class="italic">No files available (for now)</p>
  </Content>
</template>

<style lang="scss">
.raw-content {
  @apply space-y-2;

  h3 {
    @apply font-serif pt-5 text-xl sm:text-2xl italic tracking-tight text-gray-900 dark:text-white;
  }

  h4 {
    @apply pt-3 text-lg sm:text-base font-light tracking-tight text-gray-700 dark:text-gray-200;
  }

  ul {
    @apply list-disc;

    li {
      @apply ml-5;
    }
  }
}
</style>
